/**
 *  @fileOverview Entry Pathway Lead Gen Module, initialise and generate lead gen forms (slight modification to LeadGenModule)
 *
 *  @author       Aaron Chapman
 *
 */

function EntryPathwayLeadGenModule (axios, Pristine) {
  /**
  * @description Initialises lead gen form instances.
  *
  * @example
  * //
  * @returns {boolean} // null.
  */

  let pristine
  let entryPathwayLeadGenSection = document.querySelector('.entryPathwayLeadGen')
  let formButtons = ''

  let url = 'https://webservices.web.ecu.edu.au/salesforce/lead-processor.php'

  if (process.env.NODE_ENV !== 'production') {
    url = 'https://webservicesdev.web.ecu.edu.au/salesforce/lead-processor.php'
  }

  this.init = function () {
    createFormButtons()
  }

  let createFormButtons = function () {
    formButtons = document.querySelectorAll('.button--entryPathwayLeadGen')

    Array.from(formButtons).forEach(formButton => {
      formButton.addEventListener('click', createForm)
    })
  }

  let submitForm = function (event) {
    event.preventDefault()

    if (document.getElementById('emailOptOut').checked) {
      document.getElementById('hiddenOpt').setAttribute('disabled', 'disabled')
    }

    let entryPathwayLeadGenForm = entryPathwayLeadGenSection.querySelector('.entryPathwayLeadGen__form')

    let submitBtn = entryPathwayLeadGenForm.querySelector('input[type=submit]')

    var valid = pristine.validate()

    if (valid) {
      submitBtn.value = 'Processing...'
      submitBtn.setAttribute('disabled', 'disabled')

      axios.post(url, serialize(entryPathwayLeadGenForm))
        .then(function (response) {
          // Trim whitespace, them slice the () returned from SF and parse as JSON so we can access the outcome
          if (response.data.outcome.includes('failed')) {
            loadError()
          } else {
            loadConfirmation()
          }
        })
        .catch(function (error) {
          loadError(error)
        })
    }
  }

  /*!
   * Serialize all form data into a query string
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */

  let serialize = function (form) {
    // Setup our serialized data
    let serialized = []

    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {
      let field = form.elements[i]
      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue

      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
        for (let n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue
          serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value))
        }
      } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value))
      }
    }

    return serialized.join('&')
  }

  let loadConfirmation = function () {
    let formMarkup = entryPathwayLeadGenSection.querySelector('.entryPathwayLeadGen__form')
    formMarkup.remove()

    let formConfirmation = `
    <div class="entryPathwayLeadGen__confirmation leadGen__confirmation">
      <h2 class="base__heading base__heading--sectionHeading base__heading--small">Thanks for your expressing your interest.</h2>
      <button class="entryPathwayLeadGen__close leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
    </div>`

    entryPathwayLeadGenSection.innerHTML = formConfirmation

    createCloseButtons()
  }

  let loadError = function (error) {
    let formMarkup = entryPathwayLeadGenSection.querySelector('.entryPathwayLeadGen__form')
    formMarkup.remove()

    let formError = `
      <div class="entryPathwayLeadGen__confirmation leadGen__confirmation">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Error on submission</h2>
        <p class="base__lead">Sorry, your form was not submitted correctly.</p>
        <p>${error}</p>
        <button class="entryPathwayLeadGen__close leadGen_close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`
    entryPathwayLeadGenSection.innerHTML = formError

    createCloseButtons()
  }

  let createForm = function (event) {
    event.preventDefault()

    let urlVars = getUrlVars()
    let utmSource = ''
    let utmMedium = ''
    let utmCampaign = ''
    let utmContent = ''
    let utmTerm = ''
    let courseInterested = ''
    let courseLevel = ''
    let studyArea = ''
    let discipline = ''

    let oid = '00D7F0000002ycV'

    if (process.env.NODE_ENV !== 'production') {
      oid = '00D0p0000008aoz'
    }

    if (urlVars['utm_source'] !== undefined) {
      utmSource = urlVars['utm_source']
    }
    if (urlVars['utm_medium'] !== undefined) {
      utmMedium = urlVars['utm_medium']
    }
    if (urlVars['utm_campaign'] !== undefined) {
      utmCampaign = urlVars['utm_campaign']
    }
    if (urlVars['utm_content'] !== undefined) {
      utmContent = urlVars['utm_content']
    }

    if (event.target.dataset.utmterm !== undefined) {
      utmTerm = event.target.dataset.utmterm
    }

    if (event.target.dataset.courseinterested !== undefined) {
      courseInterested = event.target.dataset.courseinterested
    }

    if (event.target.dataset.courselevel !== undefined) {
      courseLevel = event.target.dataset.courselevel
    }

    if (event.target.dataset.studyarea !== undefined) {
      studyArea = event.target.dataset.studyarea
    }

    if (event.target.dataset.discipline !== undefined) {
      discipline = event.target.dataset.discipline
    }

    let form = `
      <div class="leadGen__formWrapper">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Express your interest</h2>
        <h3 class="base__subheading">Enter your details</h3>
        <form class="entryPathwayLeadGen__form" action="#">
          <input type="hidden" name="oid" id="oid" value="${oid}">
          <input type="hidden" name="retURL" id="retURL" value="https://www.ecu.edu.au">
          <input type="hidden" name="lead_source" id="lead_source" value="Website">
          <input type="hidden" name="Revenue_Funnel_Stage__c" id="Revenue_Funnel_Stage__c" value="Suspect">
          <input type="hidden" name="company" id="company" value="-">

          <input type="hidden" name="UTM_Source__c" id="UTM_Source__c" value="${utmSource}">
          <input type="hidden" name="UTM_Medium__c" id="UTM_Medium__c" value="${utmMedium}">
          <input type="hidden" name="UTM_Campaign__c" id="UTM_Campaign__c" value="${utmCampaign}">
          <input type="hidden" name="UTM_Content__c" id="UTM_Content__c" value="${utmContent}">
          
          <input type="hidden" name="UTM_Term__c" id="UTM_Term__c" value="${utmTerm}">

          <input type="hidden" id="Course_Interested_In__c" name="Course_Interested_In__c" value="${courseInterested}">

          <input type="hidden" id="Course_Level__c" name="Course_Level__c" value="${courseLevel}">
          <input type="hidden" id="Study_Area__c" name="Study_Area__c" value="${studyArea}">
          <input type="hidden" id="Discipline__c" name="Discipline__c" value="${discipline}">

          <div class="form-group">  
            <label class="visuallyHidden" for="first_name">Name</label>
            <input type="text" class="leadGen__input" name="first_name" value="" placeholder="First Name" required maxlength="40">
          </div>
          <div class="form-group">
            <input type="text" class="leadGen__input form-control" name="last_name" value="" placeholder="Last Name" required maxlength="80">
          </div>
          <div class="form-group">
            <label class="visuallyHidden" for="email">Email</label>
            <input type="email" class="leadGen__input form-control" name="email" value="" placeholder="Email" required>
          </div>
          <div class="form-group">
            <label class="visuallyHidden" for="mobile">Phone Number (optional)</label>
            <input type="tel" class="leadGen__input  form-control" name="mobile" value="" placeholder="Mobile (optional)">
          </div>
          <div class="checkbox leadGen__checkbox">
            <input type="hidden" name="emailOptOut" id="hiddenOpt" value='1'/>
            <input type="checkbox" name="emailOptOut" id="emailOptOut" value="0" checked>
            <label for="emailOptOut">Im happy to receive futher communications about future study opportunities from ECU.<br>You can update your preference at any time from ECU comminications sent to you.</label>
          </div>
          <div class="leadGen__button">
            <input type="submit" class="button button--dark button--entryPathwayLeadGenSubmit" value="Submit enquiry">
          </div>
        </form>
        <button class="entryPathwayLeadGen__close leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`

    entryPathwayLeadGenSection.innerHTML = form

    let entryPathwayLeadGenForm = entryPathwayLeadGenSection.querySelector('.entryPathwayLeadGen__form')

    pristine = new Pristine(entryPathwayLeadGenForm)

    entryPathwayLeadGenForm.addEventListener('submit', submitForm)

    createCloseButtons()
    entryPathwayLeadGenSection.style.display = 'block'

    const viewportOffset = entryPathwayLeadGenSection.getBoundingClientRect()
    const header = document.querySelector('.header')
    let top = 0

    if (viewportOffset !== null) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      top = viewportOffset.top + scrollTop - header.offsetHeight

      window.scroll({
        top: top,
        left: 0,
        behavior: 'smooth'
      })
    }
  }

  let closeForm = function () {
    let formWrap = entryPathwayLeadGenSection.querySelector('.leadGen__formWrapper')
    if (formWrap === null) {
      formWrap = entryPathwayLeadGenSection.querySelector('.entryPathwayLeadGen__confirmation')
    }

    if (formWrap !== null) {
      formWrap.remove()
    }
    entryPathwayLeadGenSection.style.display = 'none'
  }

  let getUrlVars = function () {
    let vars = {}
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value
    })
    return vars
  }

  let createCloseButtons = function () {
    let entryPathwayLeadGenCloseButtons = document.querySelectorAll('.entryPathwayLeadGen__close')
    Array.from(entryPathwayLeadGenCloseButtons).forEach(closeButton => {
      closeButton.addEventListener('click', function () {
        closeForm()
      })
    })
  }
}

module.exports = EntryPathwayLeadGenModule
